/* CasualOS is a set of web-based tools designed to facilitate the creation of real-time, multi-user, context-aware interactive experiences.
 *
 * Copyright (c) 2019-2025 Casual Simulation, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class UpdatePasswordCard extends Vue {
    @Prop() updatePasswordUrl: string;
    @Prop() requireParentEmail: boolean;

    get checkEmailText() {
        if (this.requireParentEmail) {
            return `Tell your parent to check their email for a message from Privo. If you don't see it, check your spam folder.`;
        } else {
            return `Check your email for a message from Privo. If you don't see it, check your spam folder.`;
        }
    }

    close() {
        this.$emit('close');
    }
}
